// 送信不可
export const NOT_EXECUTED = 1;

// 送信中
export const PENDING = 2;

// 送信成功
export const SUCCESS = 3;

// 送信失敗
export const FAILED = 4;
